import type { ValueOf } from '@deepcloud/deep-ui-utils'

export const SECTIONS = {
  INBOX: 'inbox',
  QUEUE: 'queue',
  FILES: 'files',
  FILE_NODES: 'fileNodes',
  TRASH: 'trash',
  TRASH_NODES: 'trashNodes',
} as const

export type Sections = ValueOf<typeof SECTIONS>
